<template>
  <div v-if="groupedByMonth.length > 0" class="row">
    <h2 class="col-12 mb-4">Pagos por mes</h2>

    <div class="col-12">
      <div class="row">
        <div class="col-2 offset-1">
          <h3>Año</h3>
        </div>
        <div class="col-2">
          <h3>Mes</h3>
        </div>
        <div class="col-3">
          <h3>Monto en Dolares</h3>
        </div>
        <div class="col-3">
          <h3>Monto en Pesos</h3>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div v-for="(item, index) in groupedByMonth" :key="index" class="row">
        <div class="col-2 offset-1">
          <span>{{ item.year }}</span>
        </div>
        <div class="col-2">
          <span>{{ months[item.month] }}</span>
        </div>
        <div class="col-3">
          <span>{{ item.amountInDollars | toCurrencyUSD }}</span>
        </div>
        <div class="col-3">
          <span>{{ item.amountInPesos | toCurrencyARS }}</span>
        </div>
      </div>
    </div>

    <hr class="my-1" />

    <div class="col-12 my-4">
      <div class="row font-weight-bold text-lg">
        <div class="col-4 offset-1 text-right">
          <span class="text-uppercase">Total:</span>
        </div>

        <div class="col-3">
          <span>{{ totalInDollars | toCurrencyUSD }}</span>
        </div>

        <div class="col-3">
          <span>{{ totalInPesos | toCurrencyARS }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { months } from '@/util/constants/months';

export default {
  props: {
    order: {
      type: Object,
      required: true,
    },

    receipt: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      serverConceptPayments: [],
      months,
    };
  },

  computed: {
    localConceptPayments() {
      if (!this.receipt) {
        return [];
      }

      return this.receipt.conceptPayments.map((concept) => {
        const date = new Date(concept.accreditationDate);
        const month = date.getUTCMonth() + 1;
        const year = date.getUTCFullYear();

        return {
          amountInDollars: Number(concept.amountInDollars),
          amountInPesos: Number(concept.amountInPesos),
          month,
          year,
        };
      });
    },

    conceptPayments() {
      return this.localConceptPayments.concat(this.serverConceptPayments);
    },

    groupedByMonth() {
      const groupedByMonth = this.conceptPayments.reduce((acc, concept) => {
        const key = `${concept.year}-${concept.month}`;

        (acc[key] = acc[key] || []).push(concept);

        return acc;
      }, {});

      return Object.values(groupedByMonth)
        .map((values) => {
          return {
            month: values.at(0).month,
            year: values.at(0).year,
            amountInDollars: values.reduce((acc, concept) => acc + Number(concept.amountInDollars), 0),
            amountInPesos: values.reduce((acc, concept) => acc + Number(concept.amountInPesos), 0),
          };
        })
        .sort((current, next) => {
          const currCompare = `${current.year}-${Number(current.month).toString().padStart(2, '0')}`;
          const nextCompare = `${next.year}-${Number(next.month).toString().padStart(2, '0')}`;

          return currCompare.localeCompare(nextCompare);
        });
    },

    totalInDollars() {
      return this.conceptPayments.reduce((acc, concept) => acc + Number(concept.amountInDollars), 0);
    },

    totalInPesos() {
      return this.conceptPayments.reduce((acc, concept) => acc + Number(concept.amountInPesos), 0);
    },
  },

  watch: {
    order: {
      immediate: true,
      handler() {
        this.fetchConceptPaymentByMonths();
      },
    },
  },

  methods: {
    fetchConceptPaymentByMonths() {
      this.$services
        .resource('orders')
        .byMonths(this.order.id)
        .then((res) => (this.serverConceptPayments = res.data));
    },
  },
};
</script>
